<p>
  {{ data.message}}
</p>
